
import {Component, Vue} from 'vue-property-decorator';
import ExportExcelDialog from '@/components/ExportExcelDialog.vue';

@Component({
  components: {ExportExcelDialog}
})
export default class FinesExportExcel extends Vue {

  view = false;

}
